function getUrlParams(url) {
  const urlParts = url.split('?');
  const search = urlParts[1];

  if (search) {
    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', (key, value) => { return key === '' ? value : decodeURI(value); });
  }

  return {};
}

function setUrlParams(url, params) {
  const urlParts = url.split('?');
  const paramsStr = Object.keys(params).map(key => `${key}=${encodeURI(params[key])}`).join('&');

  return urlParts[0] + (paramsStr.length === 0 ? '' : ('?' + paramsStr));
}

module.exports = {
  get: getUrlParams,
  set: setUrlParams,
};




// WEBPACK FOOTER //
// ./front/bankomania/js/utils/url-params.js